import { Navigate, useLocation } from "react-router";
import { useAppSelector } from "store";
import { selectCurrentUserId } from "_utils/slices/authSlice";
import { Suspense } from "react";

const ProtectedRoute = ({ children }) => {
    const user = useAppSelector(selectCurrentUserId);
    const location = useLocation();

    if (!user) {
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    return <Suspense fallback={<div></div>}>{children}</Suspense>;
};

export default ProtectedRoute;
